import { render } from "./App.vue?vue&type=template&id=fa5b405a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=fa5b405a&lang=css"

import exportComponent from "C:\\Users\\gjf1611\\code\\private\\planet-c\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__